import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, isRef as _isRef, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6119a986"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hea-flex-item1" }
const _hoisted_2 = { class: "hea-column" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-tip" }, "未成年人体检，请输入投保人手机号", -1))
const _hoisted_4 = { class: "hea-column" }
const _hoisted_5 = { class: "input-tip" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_7 = { class: "nr" }
const _hoisted_8 = { class: "notice-content hea-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/login/notice.png",
  alt: "",
  class: "notice-ico"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("关于友邦将如何处理和使用您的个人信息，请阅读")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("和")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 注册并登录 ")
const _hoisted_13 = { class: "register-tip hea-justifyC" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("已注册过，")

import { computed, defineComponent, getCurrentInstance, nextTick, onMounted, reactive, toRefs, ref } from 'vue';
    import { Toast } from 'vant';
    import JSEncryptUtils from 'utils/encrypt-utils';
    import dayjs from 'dayjs';
    import { AuthService, GenService, MemberService } from 'src/services';
    import {useToken, useUserInfo } from 'src/store';
    import { useRouter, useRoute } from 'vue-router';
    import patterns from "src/utils/patterns";
    
export default /*#__PURE__*/_defineComponent({
  emits: ["changeTab"],
  setup(__props, { emit }) {

    const { setAccessToken, setRefreshToken } = useToken();
    const { setUserInfo } = useUserInfo();
    const router = useRouter();
    const route = useRoute();

    

    // 密码输入框图标
    let showPwd = ref<boolean>(false);

    // 确认密码输入框图标
    let showConfirmPwd = ref<boolean>(false);

    // 登录信息
    let formData = reactive<any>({
        phone: "",
        code: "",
        password: "",
        confirmPassword: ""
    })

    // 是否禁用
    let timer = ref<number>(60);

    // 校验密码
    let checkPwd = () =>
    {
        if (!patterns.password.test(formData.password))
        {
            Toast({
                message: "最小长度9位数，由数字和字母组合。例如：ab1234567",
                duration: 3000
            })
        }
    }
    
    // 注册
    const onSubmit = async ()=>
    {
        try
        {
            let data = {
                timestamp: Math.floor(dayjs().valueOf() / 1000),
                phone: formData.phone,
                code: formData.code,
                password: formData.password,
                confirmPassword: formData.confirmPassword
            }
            let {content: result} = await MemberService.instance.register({
                bodyStr: JSEncryptUtils.decrypt(JSON.stringify(data))
            })

            if(result.success)
            {
                onLogin();
            }
        }
        catch(err)
        {
            Toast({
                message: err,
                duration: 4000
            })
        }
    }
    
    // 登入
    const onLogin = async ()=>
    {
        try
        {
            let data = {
                timestamp: Math.floor(dayjs().valueOf() / 1000),
                phone: formData.phone,
                password: formData.password
            }
            let {content: result} = await AuthService.instance.login({
                bodyStr: JSEncryptUtils.decrypt(JSON.stringify(data))
            })

            if(result.data)
            {
                setAccessToken(result.data.accessToken);
                setRefreshToken(result.data.refreshToken);
                setUserInfo(result.data);
                
                nextTick(()=>
                {
                    router.push({name: "home"});
                })
            }
        }
        catch(err)
        {
            Toast({
                message: err,
                duration: 4000
            })
        }
    }

    onMounted(()=>
    {
        if (localStorage.getItem("registerData"))
        {
            let jsonTemp = JSON.parse(localStorage.getItem("registerData"));
            formData.phone = jsonTemp.phone;
            formData.code = jsonTemp.code;
            formData.password = jsonTemp.password;
            formData.confirmPassword = jsonTemp.confirmPassword;
            localStorage.removeItem("registerData");
        }
    })

    // 页面跳转
    const onPage = (name: string) =>
    {
        if (name == 'fileNotice')   // 跳转告知书
        {
            localStorage.setItem("registerData", JSON.stringify(formData))
        }
        router.push({name: name});
    }

    // 获取验证码
    const onSendCode = async () : Promise<void> =>
    {
        if(!validatorPhone(formData.phone))
        {
            return;
        }
        try
        {
            let data =
            {
                timestamp: Math.floor(dayjs().valueOf() / 1000),
                smsType: 4, // 注册
                phone: formData.phone
            };

            await GenService.instance.sendSms({
                bodyStr: JSEncryptUtils.decrypt(JSON.stringify(data))
            });
           
            Toast("验证码发送成功");
            let interval = window.setInterval(() =>
            {
                timer.value--;
                if(timer.value < 0)
                {
                    timer.value = 60
                    window.clearInterval(interval);
                }
            },1000);
        }
        catch(err)
        {
            Toast({
                message: err,
                duration: 4000
            })
        }
    }

    /**
     * 验证是否正确手机号
     * @private
     * @returns void
     */
    const validatorPhone = (val: any): any =>
    {
        return patterns.mobile.test(val);
    }

    // 是否显示密码提示语
    let showPwdTip = ref<boolean>(true);

    /**
     * 密码校验
     * @private
     * @returns void
     */
    const validatorPassword = (val: any): any =>
    {
        showPwdTip.value = patterns.password.test(val);
        return patterns.password.test(val);
    }
    

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createBlock(_component_van_form, {
    onSubmit: onSubmit,
    class: "hea-column mt26"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_field, {
            clearable: "",
            modelValue: _unref(formData).phone,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).phone) = $event)),
            name: "phone",
            placeholder: "请输入友邦预留手机号码",
            rules: [{ validator: validatorPhone, message: '请输入完整手机号' }],
            maxlength: "11"
          }, null, 8, ["modelValue", "rules"]),
          _hoisted_3
        ]),
        _createVNode(_component_van_field, {
          class: "mt26",
          modelValue: _unref(formData).code,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).code) = $event)),
          center: "",
          clearable: "",
          placeholder: "请输入验证码",
          rules: [{ required: true, message: '请输入验证码' }]
        }, {
          button: _withCtx(() => [
            _createVNode(_component_van_button, {
              class: _normalizeClass(["send-code", validatorPhone(_unref(formData).phone) ? '' : 'disabled']),
              onClick: _withModifiers(onSendCode, ["stop"]),
              "native-type": "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(timer) == 60 ? '获取验证码' : `${_unref(timer)}S`), 1)
              ]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_field, {
            onClickRightIcon: _cache[2] || (_cache[2] = () => _isRef(showPwd) //@ts-ignore
 ? showPwd.value = !_unref(showPwd) : showPwd = !_unref(showPwd)),
            "right-icon": !_unref(showPwd) ? 'closed-eye' : 'eye-o',
            class: "mt26",
            clearable: "",
            modelValue: _unref(formData).password,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).password) = $event)),
            type: _unref(showPwd) ? 'text' : 'password',
            name: "密码",
            placeholder: "请输入密码",
            rules: [{ validator: validatorPassword, message: '最小长度9位数，由数字和字母组合。例如：ab1234567', trigger: 'onChange' }]
          }, null, 8, ["right-icon", "modelValue", "type", "rules"]),
          _withDirectives(_createElementVNode("div", _hoisted_5, "最小长度9位数，由数字和字母组合。例如：ab1234567", 512), [
            [_vShow, _unref(showPwdTip)]
          ])
        ]),
        _createVNode(_component_van_field, {
          onClickRightIcon: _cache[4] || (_cache[4] = () => _isRef(showConfirmPwd) //@ts-ignore
 ? showConfirmPwd.value = !_unref(showConfirmPwd) : showConfirmPwd = !_unref(showConfirmPwd)),
          "right-icon": !_unref(showConfirmPwd) ? 'closed-eye' : 'eye-o',
          class: "mt26",
          clearable: "",
          modelValue: _unref(formData).confirmPassword,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).confirmPassword) = $event)),
          type: _unref(showConfirmPwd) ? 'text' : 'password',
          name: "密码",
          placeholder: "请再次输入密码",
          rules: [{ validator: () => {
                let pd = false;
                if (_unref(formData).confirmPassword == _unref(formData).password)
                {
                    pd = true;
                }
                return pd;
            }, message: '输入的密码不一致，请您重新确认!' }]
        }, null, 8, ["right-icon", "modelValue", "type", "rules"]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", null, [
            _hoisted_10,
            _createElementVNode("span", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (onPage('fileNotice')))
            }, "《个人信息处理规则告知书》"),
            _hoisted_11,
            _createElementVNode("span", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (onPage('filePrivacy')))
            }, "《隐私声明》")
          ])
        ]),
        _createElementVNode("div", {
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(checkPwd) && _unref(checkPwd)(...args)))
        }, [
          _createVNode(_component_van_button, {
            round: "",
            block: "",
            "native-type": "submit",
            class: "submit-btn",
            color: "linear-gradient(to right, #F8628A, #E23A67)"
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("span", {
            class: "register-btn",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (emit('changeTab')))
          }, "前往登录")
        ])
      ])
    ]),
    _: 1
  }))
}
}

})